<template>
    <div class="report-table-wrapper">
        <CCTable :data="data" :columns="columns" :defaultColumns="defaultColumns"
                 :namespace="namespace" :paginationOptions="paginationOptions"
                 :fieldNameDropDown="fieldNameDropDown" :dropDownMenuUrls="dropDownMenuUrls"
                 :editableFieldsList="editableFieldsList"
                 :customTableTbodyTemplate="$options.components.customTableTBodyTemplate"
                 :customTableTheadTemplate="$options.components.customTableHeadTemplate"
                 :reportSummaryData="reportSummaryData"
        >

            <template v-if="!$md.mobile()">
                <h4 slot="cc-table-header" class="table-header-title">
                    ScrubRate Hourly Data
                </h4>
            </template>
        </CCTable>
    </div>
</template>

<script>

    import '@/style/reports/base_table_style.scss';

    import CCTable from '@/components/reports/common/table/CCTable';
    import CCTableRightSideBar from '@/components/reports/common/table/CCTableRightSideBar';
    import customTableTBodyTemplate from '@/components/reports/scrubRateHourlyReport/templates/customTableTBodyTemplate';
    import customTableHeadTemplate from '@/components/reports/scrubRateHourlyReport/templates/customTableHeadTemplate';

    import baseTableMixin from '@/components/mixins/baseTableMixin';

    import {fieldNameDropDown, dropDownMenuUrls, editableFieldsList} from '@/configs/scrubrate-hourly-report-config';

    export default {
        name: "cc-scrubrate-hourly-report-table",
        components: {
            CCTable,
            CCTableRightSideBar,
            customTableTBodyTemplate,
            customTableHeadTemplate
        },
        mixins: [
            baseTableMixin
        ],
        props: {
            data: {
                type: Array,
                required: true
            },
            reportSummaryData: {
                type: [Object, Array], 
                required: false
            }, 
            columns: {
                type: Array,
                required: true
            },
            defaultColumns: {
                type: Array,
                required: true
            },
            namespace: {
                type: String,
                required: true
            }
        },
        data(){
            return {
                chartsData: null,
                openChartsSideBar: this.$store.getters[this.namespace + '/getSideBarStatus'],
                fieldNameDropDown: fieldNameDropDown,
                dropDownMenuUrls: dropDownMenuUrls,
                editableFieldsList: editableFieldsList
            }
        },
        computed: {
            selectedSites: function(){
                let sitesObjects = this.$store.getters[this.namespace + '/getSelectedSitesObjects'];

                if (sitesObjects.length)
                {
                    return sitesObjects;
                }

                return null;
            },
        },
        created: function(){
            // this.$store.watch(() => this.$store.getters[this.namespace + '/getReportChartsData'], (chartsData) => this.updateChartsData(chartsData));
        },
        beforeMount: function(){
            if (this.$store.getters[this.namespace + '/getReportColumns'].length == 0)
            {
                this.$store.dispatch(this.namespace + '/setReportColumns', this.columns);
            }
        },
        mounted: function(){
            //this.openChartsSideBar = this.$store.getters[this.namespace + '/getSideBarStatus'];
        },
        methods: {
            updateChartsData: function(chartsData){
                this.chartsData = chartsData;
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/reports/scrubRateHourlyReport/CCScrubRateHourlyReportTable.vue